import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryCycleCountDifferenceReport'
import Component from 'components/Reports/InventoryCycleCountDifferenceReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryCycleCountDifferenceReport })(Component)
